import React from "react";

export function PageComments(pageName) {
  let jsx = null;
  switch (pageName) {
    //--------------------------------------------------------------------------
    case "home":
      return null;

    //--------------------------------------------------------------------------
    case "age":
      jsx = (
        <ul>
          <li>
            <span className="list-item-title">The age ranges</span>
            These are the only ranges that the Pilgrim's Office collects: Under 30,
            30 to 60, and over 60.
          </li>
          <li>
            <span className="list-item-title">Stability</span>
            The percentages are generally stable. The over-60 range is creeping
            up a little over the years.
          </li>
        </ul>
      );
      break;

    //--------------------------------------------------------------------------
    case "camino":
      jsx = (
        <ul>
          <li>
            <span className="list-item-title">Camino Frances</span>
            This has always been the most popular but it has been slowly
            declining in percentage (but not total pilgrims) over the years as
            other Caminos get more popular.
            It went from 70% to 60% from 2013 to 2017, just four years.
          </li>
          <li>
            <span className="list-item-title">Camino Portuguese</span>
            This has been slowly increasing over the years gaining on the Camino
            Frances and now is up to 20%.
          </li>
          <li>
            <span className="list-item-title">Caminos Norte and Primitivo</span>
            It makes some sense to combine these two as the northern alternative
            to the Camino Frances. Their combined percentage is around 10%.
            Many pilgrims start on the Camino del Norte and then follow
            the Primitivo which splits off about halfway through the Norte.
          </li>
          <li>
            <span className="list-item-title">Multiple Caminos</span>
            One might suspect that there is an increase in people walking a
            Camino multiple times. After walking the Camino Frances one or two
            times they are likely to try one of the other Caminos. But there are
            no statistics from the Pilgrim's Office indicating how many people
            have done multiple caminos.
          </li>
          <li>
            <span className="list-item-title">Camino Finisterre</span>
            One might suspect that a lot more pilgrims walk the Camino Finisterre
            than these numbers show. These numbers are from the Pilgrim's Office
            of the Santiago Cathedral. It is likely that many pilgrims walk the
            Camino Finisterre but do not register at the Pilgrim's Office.
          </li>
        </ul>
      );
      break;

    //--------------------------------------------------------------------------
    case "cityStarted":
      jsx = (
        <ul>
          <li>
            <span className="list-item-title">The data</span>
            These are the numbers and place name spellings directly from the
            Pilgrim's Office data. There are so many starting places that it is
            hard to conclude much from the data.
          </li>
          <li>
            <span className="list-item-title">Table has multiple pages</span>
            Note that this table is broken down into multiple pages.
          </li>
          <li>
            <span className="list-item-title">Sarria</span>
            Sarria is the most popular starting point, 26% of pilgrims
            start there. Sarria is the place to start on the Camino Frances if
            you want to walk 100 km and get a Compostela.
          </li>
          <li>
            <span className="list-item-title">St. Jean P. Port</span>
            St. Jean is second with 11%. This is the accepted beginning point of
            a complete Camino Frances.
          </li>
          <li>
            <span className="list-item-title">Oporto</span>
            Porto, Portugal, is a very popular place to start the Camino
            Portuguese. Tui, Spain, is the first town in Spain on the Camino
            Portuguese so is a popular starting place for an all-Spain Camino
            Portuguese. Together Porto and Tui add up to 14%.
            Lisbon, the start of the Camino Portuguese is only at 1%
          </li>
          <li>
            <span className="list-item-title">Roncesvalles</span>
            If you start at Roncesvalles you miss the first day going over the
            Pyrenees, which is the hardest leg.
            But the percentages of pilgrims starting at Roncesvalles has been going
            down steadily for 10 years and is now at only 2% compared to 11% for St. Jean.
            It seems that walking the complete Camino compensates for that hard first day.
            One might also suspect that the number of people who do the leg from St. Jean
            to Roncesvalles in two days is going up.
          </li>
        </ul>
      );
      break;

    //--------------------------------------------------------------------------
    case "completions":
      jsx = (
        <ul>
          <li>
            <span className="list-item-title">Completions by Camino</span>
            You can see completions by month for all Caminos or specific Caminos.
          </li>
          <li>
            <span className="list-item-title">One month after starting</span>
            Pilgrims usually take about a month to finish the Camino so these
            ending times are about a month after the starting times.
          </li>
          <li>
            <span className="list-item-title">
              High summer: July and August
            </span>
            These two months have about 35% of the completions. August is
            consistently the top month although it has been creeping down as the
            years go by and the Camino gets more popular. July is the
            the next most popular month.
          </li>
          <li>
            <span className="list-item-title">
              Low summer: June and September
            </span>
            Each of these months is about 14% of the total. So the four summer
            months are 63% of the total.
          </li>
          <li>
            <span className="list-item-title">
              Near summer: April, May and October
            </span>
            April is around 7%, May is around 12% and October around 10%.
          </li>
          <li>
            <span className="list-item-title">
              Near Winter: March and November
            </span>
            Each of these is around 2%.
          </li>
          <li>
            <span className="list-item-title">
              Winter: January, February and December
            </span>
            Each of these is around 1%.
          </li>
        </ul>
      );
      break;

    //--------------------------------------------------------------------------
    case "countryFrom":
      jsx = (
        <ul>
          <li>
            <span className="list-item-title">Spain</span>
            The percentage from Spain has been going steadily down over the years as
            the Camino has gotten more popular.
            Note that the percentage from Spain in Holy Years (2004 and 2010) goes way up.
            44% of the pilgrims come from Spain so we remove it from
            the graphical charts so you can see more detail in the other countries.
          </li>
          <li>
            <span className="list-item-title">Table has multiple pages</span>
            Note that this table is broken down into multiple pages.
          </li>
          <li>
            <span className="list-item-title">Germany</span>
            Germany got a "Hape Kerkeling bump" in the 2005-2009 and then
            settles down to around 8%.
          </li>
          <li>
            <span className="list-item-title">USA</span>
            The bump of pilgrims from the USA from <em>The Way</em> moved the
            USA to from 2% to 6%.
          </li>
          <li>
            <span className="list-item-title">Ireland</span>
            Ireland has more pilgrims than you would expect from their
            population.
          </li>
          <li>
            <span className="list-item-title">Korea</span>
            Korea also has a lot of pilgrims considering how far Korea is from
            Spain.
          </li>
        </ul>
      );
      break;

    //--------------------------------------------------------------------------
    case "countryStarted":
      jsx = (
        <ul>
          <li>A map of the
            <a
              href="https://en.wikipedia.org/wiki/Provinces_of_Spain"
              target="_blank"
              rel="noopener noreferrer"
            >
              Provinces of Spain
            </a>
          </li>
          <li>
            <span className="list-item-title">How this table is grouped</span>
            Since the city starting places are so numerous we decided to group
            by province (in Spain) or country (outside of Spain).
          </li>
          <li>
            <span className="list-item-title">León</span>
            León, the city, is 4% and the province is 10%.
          </li>
          <li>
            <span className="list-item-title">Holy Years</span>
            In Holy years the percent starting in Lugo goes up and the percent
            starting in Frances goes down.
          </li>
        </ul>
      );
      break;

    case "gender":
      jsx = (
        <ul>
          <li>
            <span className="list-item-title">Trends</span>
            The split is now roughly equal with slightly more men: 51% to 49%. The
            split has been slowing trending towards equality over the years.
          </li>
        </ul>
      );
      break;

    case "profession":
      jsx = (
        <ul>
          <li>
            <span className="list-item-title">Categories:</span>
            We are from the United States and are not familiar with how
            professions are classified in Spain, or in Europe, so we don't fully
            understand these professional categories. E.g., what is the
            difference between an "employee" and a "worker"? We've done our best
            to translate the professions, but some may not be quite right. We
            welcome your feedback! cpcrowley@gmail.com
          </li>
        </ul>
      );
      break;

    //--------------------------------------------------------------------------
    case "reason":
      jsx = (
        <ul>
          <li>
            <span className="list-item-title">
              Pretty consistent over the years
            </span>
            The percent for religious reasons goes up in Holy years which makes
            sense.
          </li>
        </ul>
      );
      break;

    //--------------------------------------------------------------------------
    case "spanishCityFrom":
      jsx = (
        <ul>
          <li>
            <span className="list-item-title">Overall</span>
            Not much surprising here. Numbers seem to be roughly in line with
            the populations of the regions.
          </li>
          <li>
            <span className="list-item-title">Galicia in Holy Years</span>
            Normally the percentages don't change much from year to year, but
            the percent from Galicia in Holy years goes way up. I'm not sure why
            that would be.
          </li>
        </ul>
      );
      break;

    //--------------------------------------------------------------------------
    case "travel":
      jsx = (
        <ul>
          <li>
            <span className="list-item-title">Walking</span>
            Up from 82% to 92%.
          </li>
          <li>
            <span className="list-item-title">Titles</span>
            We left the titles as they come from the Pilgrim's Office data.
          </li>
        </ul>
      );
      break;

    //--------------------------------------------------------------------------
    default:
      jsx = <li>Invalid page name: {pageName}</li>;
      break;
  }
  return <div className="footer-div">{jsx}</div>;
}



// WEBPACK FOOTER //
// ./src/PageComments.js